import { FilterOption, PriorityOption, StatusOption } from '../types/types';
import { BadgeOption } from '../types/formFields';

export const priorityOptions: PriorityOption[] = [
  { value: 'high', label: 'High' },
  { value: 'medium', label: 'Medium' },
  { value: 'low', label: 'Low' }
];

export const statusOptions: StatusOption[] = [
  { value: 'not started', label: 'Not Started' },
  { value: 'in progress', label: 'In Progress' },
  { value: 'completed', label: 'Completed' }
];

export const badgeOptions: BadgeOption[] = [
  { value: { label: 'New', bg: 'primary' }, label: 'New' },
  { value: { label: 'Urgent', bg: 'danger' }, label: 'Urgent' },
  { value: { label: 'Review', bg: 'warning' }, label: 'Review' },
  { value: { label: 'Complete', bg: 'success' }, label: 'Complete' }
];

export const sortByOptions: FilterOption[] = [
  { value: 'dueDate', label: 'Due Date' },
  { value: 'priority', label: 'Priority' },
  { value: 'createdAt', label: 'Created Date' }
];

export const sortOrderOptions: FilterOption[] = [
  { value: 'asc', label: 'Ascending' },
  { value: 'desc', label: 'Descending' }
];
